import React from "react";
import style from "./JobShare.module.css";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { jobIDIcon, jobExperienceIcon, jobLocationIcon, jobLevelIcon, hyperLink, applyJob, linkedInIcon, linkedinIcon, whatsapIcon, twitterIcon, emailIcon, XIcon } from "../../assets";

export default function JobShare() {

    const [linkToCopy, setLinkToCopy] = useState('Copy Link');

    const copyLinkHandler = async () => {
        try {
            await navigator.clipboard.writeText(window.location.href);
            toast.success("Link copied to clipboard!", { 
                duration: 2000, 
                position: "top-center",
                 style: {
                  padding: '16px',
                  color: "black",
                  fontFamily: "Helvetica",
                  maxWidth: "300px"
                },
                iconTheme: {
                  primary: '#FF9900',
                  secondary: '#FFFAEE',
                },
            });
            setLinkToCopy("Copied!");
        } catch (error) {
            alert("Failed to copy! Try again");
            setLinkToCopy("Copy Link")
        }
    }

    return(
        <div className={style.multiButton_container}>
            <div 
                title="Copy Job Link"
                className={style.copyLink_container}
                onClick={copyLinkHandler}
            >
                <img src={hyperLink} alt="%" />
            </div>
            <div 
                title="Share on LinkedIn"
                className={style.socialMedia_container}
                onClick={() => window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${window.location.href}`, "_blank")}
            >
                <img src={linkedinIcon} alt="Linkedin" />
            </div>
            <div 
                title="Share on Whatsapp"
                className={style.socialMedia_container}
                onClick={() => window.open(`https://api.whatsapp.com/send?text=${window.location.href}`, "_blank")}
            >
                <img src={whatsapIcon} alt="Whatsapp" />
            </div>
            <div 
                title="Share on X"
                className={style.socialMedia_container}
                onClick={() => window.open(`https://twitter.com/intent/tweet?url=${window.location.href}`, "_blank")}
            >
                <img src={XIcon} alt="X" />
            </div>
            {/* <div 
                title="Share via Email"
                className={style.socialMedia_container}
                // onClick={() => window.open(`mailto:?subject=Check out this job&body=${window.location.href}`, "_blank")}
            >
                <img src={emailIcon} alt="Email" />
            </div>                             */}
        </div>
    );
}
